package features.notifications.ui.utils

/**
 * Utility functions for notification UI
 */
object NotificationUtils {
    /**
     * Get emoji icon based on notification type
     * @param type Notification type
     * @return Emoji icon string
     */
    fun getNotificationIcon(type: String): String {
        return when (type) {
            "overtime_submitted" -> "⏰"
            "overtime_approved" -> "✅"
            "overtime_rejected" -> "❌"
            else -> "🔔"
        }
    }
}
